import { render, staticRenderFns } from "./SalesmanProfile.vue?vue&type=template&id=77edc640"
import script from "./SalesmanProfile.vue?vue&type=script&lang=js"
export * from "./SalesmanProfile.vue?vue&type=script&lang=js"
import style0 from "./SalesmanProfile.vue?vue&type=style&index=0&id=77edc640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports